import { render, staticRenderFns } from "./productTpye.vue?vue&type=template&id=626aed50&scoped=true"
import script from "./productTpye.vue?vue&type=script&lang=js"
export * from "./productTpye.vue?vue&type=script&lang=js"
import style0 from "./productTpye.vue?vue&type=style&index=0&id=626aed50&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626aed50",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qingchi/workspace/mimi/mer_mer_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('626aed50')) {
      api.createRecord('626aed50', component.options)
    } else {
      api.reload('626aed50', component.options)
    }
    module.hot.accept("./productTpye.vue?vue&type=template&id=626aed50&scoped=true", function () {
      api.rerender('626aed50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/product/components/productTpye.vue"
export default component.exports